/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentProgressReportProgressCurveAnalysis } from './studentProgressReportProgressCurveAnalysis';
import type { StudentProgressRecord } from './studentProgressRecord';
import type { StudentProgressReportPagination } from './studentProgressReportPagination';
import type { StudentProgressReportLevelStats } from './studentProgressReportLevelStats';
import type { CohortSummary } from './cohortSummary';

export interface StudentProgressReport {
  /** Progress curve analytics */
  progressCurveAnalysis: StudentProgressReportProgressCurveAnalysis;
  data: StudentProgressRecord[];
  pagination?: StudentProgressReportPagination;
  /** Statistics by task level (level_1, level_2, level_3) */
  levelStats?: StudentProgressReportLevelStats;
  cohortSummary: CohortSummary;
}
